// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__3F50q","content":"LayoutSettings_content__nUE_B"};